/**
 * Created by m.igrachev on 7/21/2017.
 */
import { WEBUILogs } from "../../logging";
import validationsLookUp from "./supportedValidations";
const ERROR = "error";
//TODO only for backward compatibility reasons
const legacyValidation = function(
    validationsToPerform,
    errorMessages = {},
    options = {},
    validationLevel
) {
    return (value, extraOptions = {}) => {
        let failedValidations = {};
        let consumerValidations = options.extraValidations;
        let knownValidations = Object.assign({}, validationsLookUp, consumerValidations);
        let level = validationLevel || ERROR;
        let toSet = {
            types: [],
            messages: {}
        };
        for (let validation of validationsToPerform) {
            if (!knownValidations[validation]) {
                WEBUILogs.error("Validation rule of type: " + validation + " is not defined!");
                return failedValidations;
            }
            let validationResult = knownValidations[validation](
                value,
                Object.assign({}, extraOptions, options)
            );
            if (!validationResult) {
                let message = errorMessages[validation] || errorMessages.default;
                //group by level
                toSet.types.push(validation);
                toSet.messages[validation] = message;
            }
        }
        if (toSet.types.length) {
            failedValidations[level] = toSet;
        }
        return failedValidations;
    };
};
export default function(validationsToPerform, errorMessages, options) {
    //new validation format expects validations grouped by level
    if (validationsToPerform.length && typeof validationsToPerform[0] === "string") {
        return legacyValidation(validationsToPerform, errorMessages, options);
    }
    return (value, extraOptions = {}) => {
        let result = {};
        //The validation methods will be executed with priority: "error", "warning", "info"
        //The component is responsible how to managed the priority
        Object.keys(validationsToPerform).forEach(level => {
            let { types, messages, options } = validationsToPerform[level];
            let validationResult = legacyValidation(types, messages, options, level)(
                value,
                extraOptions
            );
            if (validationResult[level]) {
                result[level] = validationResult[level];
            }
        });

        return result;
    };
}
